export default __webpack_public_path__ + "static/media/RocketDAO-great-rock_new.0240f721.svg";